import Modal from "shared/components/modal"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import "../shared_modal.scss"

interface MobileWarningProps {
  onClose: () => void
  step: string
  trackLocationType: string
  visible: boolean
}

const MobileWarning = ({ onClose, step, trackLocationType, visible }: MobileWarningProps) => {
  logIFTTTNextAction("page_viewed", {
    object_type: "upgrade_plan_modal",
    object_id: `${step}_mobile_warning`,
    location_type: trackLocationType,
  })

  return (
    <div styleName="modal-container">
      <Modal show={visible} closeListener={onClose} includeCloseX={false}>
        <h2>Upgrade with the IFTTT app</h2>
        <p>Your mobile subscription can&#39;t be updated on the web. You can upgrade your plan using the IFTTT app.</p>
        <div className="action-buttons-container">
          <button className="button-tertiary cancel-link" onClick={onClose}>
            Close
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default MobileWarning
